// extracted by mini-css-extract-plugin
export default {"CallingContainer":"calling_CallingContainer__kamS2"};